import React from "react"
import MailchimpSubscribe from "react-mailchimp-subscribe"
const url = "https://jonar.us18.list-manage.com/subscribe/post?u=bf5112e8e1d64d1a2dd78a1aa&amp;id=56a838f40e";


const SimpleForm = () => <MailchimpSubscribe url={url} />
  

export default SimpleForm